<template>
    <div>
        <div v-for="index in parseInt(cData['amount_of_filter_change'])" :key="index">
            <br>
                <p class="title">{{trans('filter_type_plate_image')}} #{{index}}</p>
                <imageInput :disabled="!edit" :keyValue="'filter_type_plate_image_' + index" :imagePath="cData['filter_type_plate_image_' + index]" @change="imageChange" />

                <!-- select main filter -->
                <p class="title">{{trans('filter_selection')}} #{{index}}</p>
                <v-select :disabled="!edit" :id="'select-'+k" v-model="cData['filter_selection_' + index]" :options="genereateOptions(['pocket_filter', 'compact_filter', 'hepa_filter', 'indiv_filter'])" :reduce="o => o.value" label="key" @input="updateData()"/>
                
                <!-- select filter specific-->
                <p v-if="cData['filter_selection_' + index] == 'hepa_filter'" class="title">{{trans('hepa_filter_selection')}} #{{index}}</p>
                <p v-else-if="cData['filter_selection_' + index] == 'compact_filter'" class="title">{{trans('compact_filter_selection')}} #{{index}}</p>
                <p v-else-if="cData['filter_selection_' + index] == 'pocket_filter'" class="title">{{trans('pocket_filter_selection')}} #{{index}}</p>
                <p v-else-if="cData['filter_selection_' + index] == 'indiv_filter'" class="title">{{trans('indiv_filter_selection')}} #{{index}}</p>
                <v-select :disabled="!edit" v-if="cData['filter_selection_' + index] == 'hepa_filter'" :id="'select-'+k" v-model="cData['hepa_filter_selection_' + index]" :options="genereateOptions(structure['hepa_filter_selection'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>
                <v-select :disabled="!edit" v-else-if="cData['filter_selection_' + index] == 'compact_filter'" :id="'select-'+k" v-model="cData['compact_filter_' + index]" :options="genereateOptions(structure['compact_filter_selection'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>
                <v-select :disabled="!edit" v-else-if="cData['filter_selection_' + index] == 'pocket_filter'" :id="'select-'+k" v-model="cData['pocket_filter_' + index]" :options="genereateOptions(structure['pocket_filter_selection'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>
                <v-select :disabled="!edit" v-else-if="cData['filter_selection_' + index] == 'indiv_filter'" :id="'select-'+k" v-model="cData['indiv_filter_' + index]" :options="genereateOptions(structure['indiv_filter_selection'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>

                <p class="title">{{trans('filter_width_in_mm')}} #{{index}}</p>
                <input :disabled="!edit" @change="updateData()" v-model="cData['filter_width_in_mm_' + index]" type="number" class="input-field">

                <p class="title">{{trans('filter_height_in_mm')}} #{{index}}</p>
                <input :disabled="!edit" @change="updateData()" v-model="cData['filter_height_in_mm_' + index]" type="number" class="input-field">

                <p class="title">{{trans('filter_depth_in_mm')}} #{{index}}</p>
                <input :disabled="!edit" @change="updateData()" v-model="cData['filter_depth_in_mm_' + index]" type="number" class="input-field">

                <p class="title">{{trans('replacement_or_cleaning')}}  #{{index}}</p>
                <v-select :disabled="!edit" :id="'select-'+k" v-model="cData['replacement_or_cleaning_' + index]" :options="genereateOptions(['replace_filter', 'clean_filter', 'dont_do_anything'])" :reduce="o => o.value" label="key" @input="updateData()"/>

                <p class="title">{{trans('filter_image')}} #{{index}}</p>
                <imageInput :disabled="!edit" :keyValue="'filter_image_' + index" :imagePath="cData['filter_image_' + index]" @change="imageChange" />
            <br>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'chillFilter',
        props: {
            cData: Object,
            edit: Boolean,
            k: String,
            structure: Object,
            updateData: Function,
            imageChange: Function
        },
        methods: {
            genereateOptions(options){
                let re = []
                for(let o of options){
                    re.push({key: this.trans(o), value: o})
                }
                return re
            }
        }
    }
</script>